<template>
  <!-- 走进武夷山 -->
  <div :key="domKey">
    <div style="position:relative">
      <TopButtom v-bind:buttonlist="buttonlist" v-on:changeDataList="changeDataList"></TopButtom>
    </div>
    <div class="tabcpage" v-show="ifShowList">
      <div class="rowA" v-show="deviceId == 1">
        <div class="english">SCENIC NEWS</div>
        <div class="chinese">景区新闻</div>
      </div>
      <div class="rowA" v-show="deviceId == 2">
        <div class="english">TRAVEL NEWS</div>
        <div class="chinese">旅游新闻</div>
      </div>
      <div class="rowB">
        <div class="body">
          <div class="line"></div>
          <div v-for="item in datalist" :key="item.key">
            <div style="display:flex;flex-direction:row" @click="seeInfo(item)">
              <div class="middleDiv">
                <img :src="item.icon" class="middleImg" v-if="item.icon != null" />
                <img src="@/assets/image/wys.png" class="middleImg" v-else />
              </div>
              <div style="display:flex;flex-direction:column">
                <div class="topTitle">{{ item.title }}</div>
                <div class="desc">{{ item.introduce }}</div>
              </div>
            </div>
            <div class="line" style="margin-top:1.3888vh"></div>
          </div>
          <div class="footer">
            <NewPagunation :nowCurrent="current" :total="total" :pageSize="pageSize" @getPage="getPage"></NewPagunation>
          </div>
        </div>
      </div>
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:1.018vh;">武夷山景区</div>
            <div style="margin-top:1.018vh;">天下难寻</div>
            <div style="margin-top:1.018vh;">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
    <DetailsInfo :info="info" @closed="closed" v-show="!ifShowList"></DetailsInfo>
  </div>
</template>
<script>
import DetailsInfo from "./detailsInfo";
import "@/css/listVertical.css";
import NewPagunation from "@/components/common/NewPagunation.vue";
import TopButtom from "@/components/common/TopButtom.vue";
import { addHits } from "@/util/publicHits";
import { getMenuOpenList } from "@/api/publicApi";// newsTravel  newsScenic
export default {
  name: "TabApage",
  components: { TopButtom, NewPagunation, DetailsInfo },
  data() {
    return {
      domKey: "",
      ifShowList: true,//是否显示列表
      info: {},
      current: 1,
      pageSize: 3,
      total: 0,
      datalist: [],
      buttonlist: [
        {
          id: 1,
          leftS: "left:1.5625vw",
          leftX: "left:1.458vw",
          title: "景区新闻",
          noCheckX: false
        },
        {
          id: 2,
          leftS: "left:10.5208vw",
          leftX: "left:10.4167vw",
          title: "旅游新闻",
          noCheckX: true
        }
      ]
    };
  },
  watch: {
    deviceId: {
      handler(deviceId) {
        this.buttonlist.forEach(element => {
          element.id == deviceId
            ? (element.noCheckX = false)
            : (element.noCheckX = true);
        });
        this.current = 1;
        let timestamp = Date.parse(new Date());
        this.domKey = timestamp;
        if (deviceId == 1) {
          this.getNewsScenicFunction();
        } else if (deviceId == 2) {
          this.getNewsTravelFunction();
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    deviceId() {
      return this.$store.state.tabPage;
    }
  },
  methods: {
    //切换标签
    changeDataList(type) {
      this.$store.commit("setTabPage", type);
      let name = "NewsTab";
      this.$emit("specialtyListFunction", name);
    },
    //详情
    seeInfo(info) {
      let deviceId = this.deviceId;
      if (deviceId == 1) {
        addHits(info.id)
      } else if (deviceId == 2) {
        addHits(info.id)
      }
      this.info = info;
      this.ifShowList = false;
    },
    //分页
    getPage(current) {
      this.current = current;
      if (this.deviceId == 1) {
        this.getNewsScenicFunction();
      } else if (this.deviceId == 2) {
        this.getNewsTravelFunction();
      }
    },
    //景区新闻
    async getNewsScenicFunction() {
      const { code, data } = await getMenuOpenList(0, 'news_scenic', this.current, this.pageSize);
      if (code == 200) {
        this.datalist = data.records;
        let BASE_URL = this.Global;
        this.datalist.forEach(element => {
          element.introduce != null
            ? (element.introduce = element.introduce.slice(0, 176) + ".....")
            : "";
          element.icon != null
            ? (element.icon = `${BASE_URL}${element.icon}`)
            : "";
        });
        this.total = data.total;
      }
    },
    //旅游新闻
    async getNewsTravelFunction() {
      const { code, data } = await getMenuOpenList(0, 'news_travel', this.current, this.pageSize);
      if (code == 200) {
        this.datalist = data.records;
        let BASE_URL = this.Global;
        this.datalist.forEach(element => {
          element.introduce != null
            ? (element.introduce = element.introduce.slice(0, 176) + ".....")
            : "";
          element.icon != null
            ? (element.icon = `${BASE_URL}${element.icon}`)
            : "";
        });
        this.total = data.total;
      }
    },
    //返回
    closed() {
      let deviceId = this.deviceId;
      if (deviceId == 1) {
        this.getNewsScenicFunction();
      } else if (deviceId == 2) {
        this.getNewsTravelFunction();
      }
      this.ifShowList = true;
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/newsInfo/newsTab.vue